export default __webpack_public_path__ + "static/media/marketplace-hover.cabbc088.svg";